import React, { Component } from "react";
import {
  Button,
  ButtonGroup,
  Container,
  Col,
  Row,
  Table,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
} from "reactstrap";
import axios from "axios";
import numeral from "numeral";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

class LoanDetails extends Component {
  state = {
    loan: "",
    note: "",
    load: true,
    banks: null,
    bankcode: null,
    resolvedAccount: null,
    err: "",
    modal: null,
    type: "resolve",
    amountToSend: null,
    narration: "Loan Disbursement",
  };

  toggle = (modal = true) => {
    this.setState({
      modal,
    });
  };

  componentDidMount() {
    axios
      .get(`/api/loanDetails/${this.props.match.params.loanId}`, {
        headers: { Authorization: localStorage.getItem("token") },
      })
      .then((response) => {
        //   console.log(response.data);
        this.setState({
          loan: response.data[0],
          amountToSend: response.data[0].loanAmount,
          load: false,
        });
        axios
          .get("/api/getBankList", {
            headers: { Authorization: localStorage.getItem("token") },
          })
          .then((resp) => {
            this.setState({
              banks: resp.data.data,
            });
          })
          .catch((err) => {
            console.error(err.response);
          });
      })
      .catch((err) => {
        console.log(err.response);
      });
  }

  resolveAccount = (e) => {
    e.preventDefault();
    this.setState({
      load: true,
    });
    if (this.state.bankcode) {
      axios
        .post(
          "/api/resolveAccount",
          {
            account_number: this.state.loan.clientinfo.accountNumber,
            bank_code: this.state.bankcode,
          },
          { headers: { Authorization: localStorage.getItem("token") } }
        )
        .then(({ data }) => {
          this.setState({
            resolvedAccount: data.data.account_name,
            load: false,
          });
        })
        .catch((err) => {
          this.setState({
            load: false,
          });
          alert("Could not resolve account");
          console.error(err.response);
        });
    }
  };

  sendMoney = (e) => {
    e.preventDefault();

    if (
      window.confirm(
        `Are you sure you want to send ${numeral(
          this.state.amountToSend
        ).format("0,0.00")} to ${this.state.resolvedAccount}`
      )
    ) {
      this.setState({
        load: true,
      });
      axios
        .post(
          "/api/sendMoney",
          {
            purchaseReference: `checkoff/${this.props.match.params.loanId}`,
            amount: this.state.amountToSend,
            bankcode: this.state.bankcode,
            accountNumber: this.state.loan.clientinfo.accountNumber,
            currency: "NGN",
            senderName: `Checkoff - ${this.props.user.name}(${this.props.user.email})`,
            narration: this.state.narration,
          },
          { headers: { Authorization: localStorage.getItem("token") } }
        )
        .then((data) => {
          this.setState({
            load: false,
          });
          window.alert(
            "Money sent to user. please confirm on your giro dashboard"
          );
        })
        .catch((err) => {
          this.setState({
            load: false,
          });
          window.alert(
            "Could not send money, please check your giro dashboard"
          );
          console.error(err.response);
        });

      axios
        .post(
          "/api/resolveAccount",
          {
            account_number: this.state.loan.clientinfo.accountNumber,
            bank_code: this.state.bankcode,
          },
          { headers: { Authorization: localStorage.getItem("token") } }
        )
        .then(({ data }) => {
          this.setState({
            resolvedAccount: data.data.account_name,
            load: false,
          });
        })
        .catch((err) => {
          this.setState({
            load: false,
          });
          window.alert("Could not resolve account");
          console.error(err.response);
        });
    }
  };

  loanstatus = (status) => {
    let type = null;
    if (status === 1) {
      type = "Unapproved";
    } else if (status === 5) {
      type = "Approved";
    } else if (status === 3) {
      type = "Modification Requested";
    } else if (status === 7) {
      type = "Disbursed";
    } else if (status === 9) {
      type = "Rejected";
    }
    return type;
  };

  actionType = async (status) => {
    if (window.confirm("are you sure?")) {
      this.setState({ load: true, err: "" });

      try {
        const data = await axios.post(
          `/api/loanAction/${status}`,
          {
            note: this.state.note,
            _id: this.state.loan._id,
            bankcode: this.state.bankcode,
            direct: this.state.direct,
            email: this.props.user.email,
            name: this.props.user.name,
          },
          { headers: { Authorization: localStorage.getItem("token") } }
        );
        // console.log(data.data);

        axios
          .get(`/api/loanDetails/${this.props.match.params.loanId}`, {
            headers: { Authorization: localStorage.getItem("token") },
          })
          .then((response) => {
            //    console.log(response.data[0]);
            this.setState({
              loan: response.data[0],
              amountToSend: response.data[0].loanAmount,
              load: false,
            });
          })
          .catch((err) => {
            console.log(err.response);
          });
      } catch (error) {
        if (
          error.response &&
          error.response.data &&
          typeof error.response.data === "string"
        )
          toast.error(error.response.data);

        toast("an error occured");
      } finally {
        this.setState({ load: false });
      }
    }
  };

  render() {
    return (
      <Container>
        <Modal
          centered
          size="sm"
          isOpen={this.state.modal}
          backdrop={false}
          toggle={() => {
            this.toggle(null);
          }}
        >
          <ModalHeader
            toggle={() => {
              this.toggle(null);
            }}
            charCode="X"
          >
            {this.state.type == "resolve" ? (
              !this.state.resolvedAccount ? (
                "Resolve Account Number"
              ) : (
                <span style={{ color: "red" }}>
                  {this.state.resolvedAccount}
                </span>
              )
            ) : this.state.resolvedAccount ? (
              "Disburse Loan"
            ) : (
              <span style={{ color: "red" }}>
                you have to resolve the account number before you can transfer!
              </span>
            )}
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12} className="my-2">
                {this.state.type == "resolve" ? (
                  <Form
                    className="d-flex flex-column"
                    onSubmit={(e) =>
                      !this.state.resolvedAccount
                        ? this.resolveAccount(e)
                        : e.preventDefault()
                    }
                  >
                    <FormGroup>
                      <Input
                        bsSize="sm"
                        type="select"
                        onChange={(e) =>
                          this.setState({ bankcode: e.target.value })
                        }
                      >
                        <option>-- Select Bank --</option>
                        {Object.entries(
                          this.state.banks ? this.state.banks : {}
                        )
                          .sort((a, b) => (a[1] <= b[1] ? -1 : 1))
                          .map(([key, value]) => (
                            <option key={key} value={key}>
                              {value}
                            </option>
                          ))}
                      </Input>
                    </FormGroup>
                    <FormGroup>
                      <Input
                        bsSize="sm"
                        type="number"
                        defaultValue={
                          this.state.loan &&
                          this.state.loan.clientinfo.accountNumber
                        }
                        disabled
                      />
                    </FormGroup>
                    <Button
                      disabled={this.state.resolvedAccount || this.state.load}
                      type="submit"
                      className="align-self-center"
                      onClick={this.resolveAccount}
                      color="success"
                      size="sm"
                    >
                      Resolve!
                    </Button>
                  </Form>
                ) : (
                  <Form
                    className="d-flex flex-column"
                    onSubmit={(e) =>
                      this.state.resolvedAccount
                        ? this.sendMoney(e)
                        : e.preventDefault()
                    }
                  >
                    <FormGroup>
                      <Input
                        bsSize="sm"
                        type="select"
                        disabled
                        onChange={(e) =>
                          this.setState({ bankcode: e.target.value })
                        }
                        value={this.state.bankcode}
                      >
                        <option>-- Select Bank --</option>
                        {Object.entries(
                          this.state.banks ? this.state.banks : {}
                        )
                          .sort((a, b) => (a[1] <= b[1] ? -1 : 1))
                          .map(([key, value]) => (
                            <option key={key} value={key}>
                              {value}
                            </option>
                          ))}
                      </Input>
                    </FormGroup>
                    <FormGroup>
                      <Input
                        bsSize="sm"
                        type="number"
                        defaultValue={
                          this.state.loan &&
                          this.state.loan.clientinfo.accountNumber
                        }
                        disabled
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label size="sm">Amount to send</Label>

                      <Input
                        bsSize="sm"
                        type="number"
                        value={this.state.amountToSend}
                        placeholder="amount..."
                        onChange={(e) =>
                          this.setState({ amountToSend: e.target.value })
                        }
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label size="sm">Sender</Label>
                      <Input
                        bsSize="sm"
                        type="text"
                        defaultValue={`Checkoff - ${this.props.user.name}(${this.props.user.email})`}
                        disabled
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label size="sm">narration</Label>
                      <Input
                        bsSize="sm"
                        type="text"
                        value={this.state.narration}
                        onChange={(e) =>
                          this.setState({ narration: e.target.value })
                        }
                      />
                    </FormGroup>
                    <Button
                      disabled={!this.state.resolvedAccount || this.state.load}
                      type="submit"
                      className="align-self-center"
                      onClick={this.sendMoney}
                      color="success"
                      size="sm"
                    >
                      {!this.state.resolvedAccount
                        ? "resolve first!"
                        : "Send Money"}
                    </Button>
                  </Form>
                )}
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button
              color="danger"
              className="w-100"
              size="sm"
              onClick={() => {
                this.toggle(null);
              }}
            >
              Close
            </Button>
          </ModalFooter>
        </Modal>
        <Row>
          <Col md={12}>
            <Table striped hover responsive>
              {this.state.loan ? (
                <tbody>
                  <tr>
                    <th>DSE</th>
                    <td>{this.state.loan.dse}</td>
                  </tr>
                  <tr>
                    <th>Client Name</th>
                    <td>
                      {this.state.loan.clientinfo.firstname}{" "}
                      {this.state.loan.clientinfo.lastname}(
                      {this.state.loan.clientinfo.gender})
                    </td>
                  </tr>
                  <tr>
                    <th>Client ID</th>
                    <td>
                      <Link
                        to={{
                          pathname: `/clientdetails/${this.state.loan.clientinfo._id}`,
                          state: { client: this.state.loan.clientinfo },
                        }}
                      >
                        {this.state.loan.clientinfo.clientId}
                      </Link>
                    </td>
                  </tr>
                  <tr>
                    <th>Loan ID</th>
                    <td>{this.state.loan.loanId}</td>
                  </tr>
                  <tr>
                    <th>Phone Number</th>
                    <td>{this.state.loan.clientinfo.phoneNumber}</td>
                  </tr>
                  <tr>
                    <th>Email</th>
                    <td>{this.state.loan.clientinfo.email}</td>
                  </tr>
                  <tr>
                    <th>Address</th>
                    <td>{this.state.loan.clientinfo.address}</td>
                  </tr>
                  <tr>
                    <th>Date of Birth</th>
                    <td>
                      {this.state.loan.clientinfo.dob
                        ? this.state.loan.clientinfo.dob.split("T")[0]
                        : ""}
                    </td>
                  </tr>
                  {/* <tr>
                      <th>Client Recruiter</th>
                      <td>
                        {this.state.loan.clientinfo.clientEmployer}
                      </td>
                    </tr> */}
                  <tr>
                    <th>Client Employer</th>
                    <td>{this.state.loan.clientinfo.employer}</td>
                  </tr>
                  {/* <tr>
                      <th>Job Description</th>
                      <td>
                        {'jobdesc' in this.state.loan && this.state.loan.jobdesc}
                      </td>
                    </tr> */}
                  {/* <tr>
                      <th>Official Email Address</th>
                      <td>
                        {this.state.loan.clientinfo.officialEmailAddress}
                      </td>
                    </tr> */}
                  <tr>
                    <th>Client Employer Number</th>
                    <td>
                      {this.state.loan.clientinfo.employeeNumber
                        ? this.state.loan.clientinfo.employeeNumber
                        : ""}
                    </td>
                  </tr>
                  {/* <tr>
                      <th>Income Range</th>
                      <td>
                        {this.state.loan.clientinfo.incomeRange}
                      </td>
                    </tr> */}
                  <tr>
                    <th>Monthly Salary</th>
                    <td>
                      {numeral(this.state.loan.clientinfo.monthlySalary).format(
                        "0,0.00"
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th>Next Salary Date</th>
                    <td>{this.state.loan.clientinfo.nextSalaryDate}</td>
                  </tr>
                  <tr>
                    <th>Bank</th>
                    <td>{this.state.loan.clientinfo.bank}</td>
                  </tr>
                  <tr>
                    <th>bvn</th>
                    <td>{this.state.loan.clientinfo.bvn}</td>
                  </tr>

                  <tr>
                    <th>Account Number</th>
                    <td>
                      {this.state.loan.clientinfo.accountNumber}{" "}
                      {this.props.user.employer == "CHECKOFF" ? (
                        <Button
                          onClick={() => {
                            this.setState({ type: "resolve" });
                            this.toggle();
                          }}
                          color="secondary"
                          size="sm"
                        >
                          Resolve Account Number
                        </Button>
                      ) : null}
                      {this.state.resolvedAccount && (
                        <React.Fragment>
                          <br />
                          <small style={{ color: "red" }}>
                            This account Number Belongs to{" "}
                            {this.state.resolvedAccount}
                          </small>
                        </React.Fragment>
                      )}
                    </td>
                  </tr>
                  {/* <tr>
                      <th>Retirement Savings Account</th>
                      <td>
                        {this.state.loan.clientinfo.rsa}
                      </td>
                    </tr> */}
                  <tr>
                    <th>Loan Amount</th>
                    <td>
                      {numeral(this.state.loan.loanAmount).format("0,0.00")}{" "}
                      {(this.state.loan.status == 5 ||
                        this.state.loan.status == 7) &&
                      this.props.user.employer == "CHECKOFF" ? (
                        <Button
                          onClick={() => {
                            this.setState({ type: "send" });
                            this.toggle();
                          }}
                          color="success"
                          size="sm"
                        >
                          Disburse
                        </Button>
                      ) : null}
                    </td>
                    {/* <td>
                        <Button onClick={() => { this.setState({ type: 'send' }); this.toggle(); }} color="danger" size="sm">
                          Edit
                        </Button>
                      </td> */}
                  </tr>
                  <tr>
                    <th>Amount Disbursable</th>
                    <td>
                      {numeral(this.state.loan.amountDisbursable).format(
                        "0,0.00"
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th>Repayment</th>
                    <td>
                      {numeral(this.state.loan.repayment).format("0,0.00")}
                    </td>
                  </tr>
                  <tr>
                    <th>Loan Tenure</th>
                    <td>{this.state.loan.loanTenor}</td>
                    {/* <td>
                        <Button onClick={() => { this.setState({ type: 'send' }); this.toggle(); }} color="danger" size="sm">
                          Edit
                        </Button>
                      </td> */}
                  </tr>

                  <tr>
                    <th>Submitted</th>
                    <td>{this.state.loan.submittedOnDate}</td>
                  </tr>
                  <tr>
                    <th>Status</th>
                    <td>{this.loanstatus(this.state.loan.status)}</td>
                  </tr>
                </tbody>
              ) : null}
            </Table>
          </Col>
        </Row>

        {this.state.err ? (
          <Row className="justify-content-center mb-3">
            <h6>{this.state.err}</h6>
          </Row>
        ) : null}
        {this.state.load ? (
          <Row className="justify-content-center mb-3">
            <h6>Loading.... Please Wait</h6>
          </Row>
        ) : (
          <React.Fragment>
            {/* <FormGroup row className="my-4">
                <Label for="exampleText" sm={2} />
                <Col sm={10}>
                  <Input bsSize="lg" type="textarea" onChange={(e) => { this.setState({ note: e.target.value }); }} placeholder="Note" name="text" id="exampleText" />
                </Col>
              </FormGroup> */}
            <Row className="my-5 justify-content-around">
              {this.state.loan.status == 1 || this.state.loan.status == 3 ? (
                <Button
                  onClick={() => {
                    this.actionType(5);
                  }}
                  color="success"
                >
                  Approve Loan
                </Button>
              ) : null}
              {/* {this.state.loan.status == 1 ? (
  <Button onClick={() => { this.actionType(3); }} color="secondary">
            Request Modification
  </Button>
) : null } */}
              {/* {this.state.loan.status == 5 && this.props.user.employer == 'CHECKOFF' ? (
                  <Button onClick={() => { this.actionType(7); }} color="primary">
                    Disburse Loan
                  </Button>
                ) : null} */}
              {(this.state.loan.status == 1 || this.state.loan.status == 3) &&
              this.props.user.employer == "CHECKOFF" ? (
                <Button
                  onClick={() => {
                    this.actionType(9);
                  }}
                  color="danger"
                >
                  Reject Loan
                </Button>
              ) : null}
            </Row>
          </React.Fragment>
        )}
      </Container>
    );
  }
}

export default LoanDetails;
